module.exports = __webpack_public_path__ + "static/media/EHS-Recruitment-and-Selection.fc8a0c6d.pdf";